require('./brokerMiFIDNotAllowed.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { MYPROFILE_BROKER_URL } = require('constants/index');

class BrokerMiFIDNotAllowed extends React.Component {

    buildButtons() {
        const { onCancel } = this.props;

        return (
            <footer className="broker-mifid-not-allowed__footer text-right">
                <div className="pull-left">
                    <OKButton modifier="link-ghost" onClick={onCancel}>
                        <FormattedText value="broker-convenienceMifidTestCancel"/>
                    </OKButton>
                </div>
                <OKButton
                    modifier="secondary"
                    to={MYPROFILE_BROKER_URL}
                >
                    <FormattedText value="broker-convenienceMifidTestGoToMyWallet"/>
                </OKButton>
            </footer>
        );
    }

    buildDisclaimer() {
        const { disclaimerText } = this.props;
        const warningDisclaimerText = formatText('broker-convenienceMifidTestWarningDisclaimerText');

        return (
            <div className="broker-mifid-not-allowed__disclaimer-message">
                <OKMessage>
                    {warningDisclaimerText}
                    {disclaimerText}
                </OKMessage>
            </div>
        );
    }

    buildNoCancelButtons() {
        return (
            <footer className="broker-mifid-not-allowed__footer text-right">
                <OKButton
                    modifier="secondary"
                    to={MYPROFILE_BROKER_URL}
                >
                    <FormattedText value="broker-convenienceMifidTestGoToMyWallet"/>
                </OKButton>
            </footer>
        );
    }

    buildResult() {
        const { resultText } = this.props;
        if (resultText) {
            return (
                <div>
                    <h4 className="broker-mifid-not-allowed__info-title">
                        <FormattedText value="consultMiFID-investorEvaluation" format="uppercase"/>
                    </h4>
                    <p className="broker-mifid-not-allowed__info-bold">
                        {resultText}
                    </p>
                    <OKMessage>
                        <div>
                            <FormattedText className="broker-mifid-not-allowed__info" value="consultMiFID-infoTestExpiration"/>
                        </div>
                        <div>
                            <FormattedText className="broker-mifid-not-allowed__info" value="consultMiFID-redoTestLater"/>
                        </div>
                    </OKMessage>
                </div>
            );
        }
    }

    render() {
        const { isTestOmitted, cancelButtonAvailable } = this.props;
        let result;
        let disclaimerContent;
        let titleContent;
        const buttons = cancelButtonAvailable ? this.buildButtons() : this.buildNoCancelButtons();

        if ( isTestOmitted ) {
            disclaimerContent = this.buildDisclaimer();
            titleContent = formatText('broker-convenienceMifidTestOperateOmittingTest');
        }
        else {
            titleContent = formatText('consultMiFID-subtitle');
            result = this.buildResult();
        }
        return (
            <ContentBox
                title={titleContent}
                titleSeparator={true}
            >
                {result}
                {disclaimerContent}

                {buttons}
            </ContentBox>
        );
    }
}

BrokerMiFIDNotAllowed.propTypes = {
    disclaimerText: PropTypes.string.isRequired,
    resultText: PropTypes.string.isRequired,
    isTestOmitted: PropTypes.bool.isRequired,
    clientEmail: PropTypes.string.isRequired,
    cancelButtonAvailable: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired
};

module.exports = BrokerMiFIDNotAllowed;
